var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasRouteFilter && _vm.routeFilter === _vm.CrmRouteEnum.Clients)?_c('app-clients-page'):(_vm.hasRouteFilter && _vm.routeFilter === _vm.CrmRouteEnum.Administration)?_c('app-admin-page'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }